import { Platform, StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorInfo, colorText, space4, space2 } = theme();

  const arrowWidth = space2;
  const margin = space2;

  return StyleSheet.create({
    arrow: {
      borderColor: colorInfo,
      borderStyle: "solid",
      borderWidth: arrowWidth,
      height: 0,
      left: arrowWidth / 2,
      pointerEvents: "none",
      position: "absolute",
      transform: [{ rotate: "45deg" }],
      width: 0,
    },
    arrowBottom: {
      top: arrowWidth,
    },
    arrowTop: {
      bottom: arrowWidth,
    },
    container: {
      position: "relative",
      zIndex: 3,
    },
    content: {
      backgroundColor: colorInfo,
      color: colorText,
      left: -arrowWidth * 2,
      padding: space4,
      position: "absolute",
    },
    contentBottom: {
      top: arrowWidth + margin,
    },
    contentTop: {
      bottom: arrowWidth + margin,
    },
    contentWrapper: {
      ...Platform.select({
        native: {
          width: "100%",
          minWidth: 150,
        },
        web: {
          display: "flex",
          flexGrow: 1,
          minWidth: 100,
          maxWidth: 250,
        },
      }),
    },
    wrapper: {
      position: "absolute",
      width: "100%",
    },
    wrapperBottom: {
      bottom: "auto",
      top: "100%",
    },
    wrapperTop: {
      bottom: "100%",
      top: "auto",
    },
  });
};

export { style };
